import PropTypes from 'prop-types'
import React from 'react'
import { ErrorMessage, getIn } from 'formik'

const CheckboxField = ({
  options,
  field,
  children,
  className,
  form: { touched, errors },
  isDisabled = false,
  formikProps,
  checked,
  categoryName,
  handleCheckbox
}) => {
  const { description } = options || { description: null }
  const { value } = { ...field }
  return (
    <div
      className={`checkbox-group ${className || ''} ${getIn(errors, field.name) &&
        getIn(touched, field.name)
        ? 'has-error'
        : ''}`}
      data-qa="checkbox"
    >
      <label
        onClick={e => {
          e.stopPropagation()
        }}
      >
        <input
          {...field}
          type="checkbox"
          onClick={e => {
            e.stopPropagation()
            field.onChange(e)
            field.onBlur(e)
          }}
          disabled={isDisabled}
          checked={value}
          className={`checkbox  checkbox-default ${className || ''}        
          ${getIn(errors, field.name) && getIn(touched, field.name) ? 'has-error' : ''}
        `}
        />

        {description != null
          ? description.key
          : children}
      </label>
      <ErrorMessage
        name={field.name}
        render={msg =>
          <div className="help-block" data-qa="input-error">
            {msg}
          </div>}
      />
    </div>
  )
}

CheckboxField.propTypes = {
  field: PropTypes.shape({}),
  className: PropTypes.arrayOf(PropTypes.any),
  form: PropTypes.shape({})
}

export default CheckboxField
